<template lang="pug">
  div
    OVDetail
</template>

<script>
import OVDetail from '../../components/OV/OVDetail.vue';

export default {
  name: 'OVDetailView',
  components: {
    OVDetail
  },
  data() {
    return {
      isModalVisible: false
    };
  }
};
</script>